import { Heart, Truck, Layers } from "lucide-react";
import { img, tl } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ p, onOpen, index = 0 }) {
  const { add } = useCart();
  const out = p.stock <= 0;
  return (
    <div
      data-testid={`product-card-${p.id}`}
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
      className="rise group relative bg-white rounded-lg border border-slate-200 flex flex-col overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow] duration-200"
    >
      <div className="absolute top-3 left-3 z-10 flex flex-col gap-1 items-start">
        {p.cargo_included && <span className="flex items-center gap-1 text-[11px] font-bold text-[#15803D] bg-[#DCFCE7] px-2 py-0.5 rounded"><Truck className="h-3 w-3" />Ücretsiz Kargo</span>}
        {p.is_campaign && <span className="text-[11px] font-bold text-white bg-[#172554] px-2 py-0.5 rounded">Kampanya</span>}
      </div>
      <button className="absolute top-3 right-3 z-10 text-slate-400 hover:text-red-500" aria-label="Favori" data-testid={`product-fav-${p.id}`}>
        <Heart className="h-5 w-5" />
      </button>
      <button onClick={() => onOpen(p)} data-testid={`product-open-${p.id}`} className="block bg-white p-4 pt-8">
        <img src={img(p.image)} alt={p.name} loading="lazy" className="h-44 sm:h-52 w-full object-contain group-hover:scale-105 transition-transform duration-300" />
      </button>
      <div className="px-4 pb-4 flex flex-col flex-1">
        <div className="text-[11px] font-bold uppercase tracking-wider text-slate-400">{p.brand}</div>
        <button onClick={() => onOpen(p)} className="text-left text-sm font-semibold text-slate-900 leading-snug line-clamp-2 min-h-[40px] hover:text-[#172554]">
          {p.name} {p.weight}
        </button>
        {p.bulk_price && (
          <div className="mt-1 flex items-center gap-1 text-[11px] font-semibold text-[#172554]"><Layers className="h-3 w-3" />{p.bulk_min_qty}+ adette %{p.bulk_discount_pct} ek indirim</div>
        )}
        <div className="mt-auto pt-3 flex items-center gap-2 flex-wrap">
          {p.discount_pct > 0 && <span className="bg-[#16A34A] text-white text-xs font-bold px-1.5 py-0.5 rounded">-%{Math.round(p.discount_pct)}</span>}
          <span data-testid={`product-price-${p.id}`} className="text-[17px] font-extrabold text-[#15803D]">{tl(p.sale_price)}</span>
          {p.old_price && <span className="text-xs text-slate-400 line-through">{tl(p.old_price)}</span>}
        </div>
        <button
          data-testid={`product-add-${p.id}`}
          disabled={out}
          onClick={() => add(p)}
          className="mt-3 h-10 rounded-md bg-[#172554] text-white text-sm font-bold hover:bg-[#1E3A8A] active:translate-y-px transition-colors disabled:bg-slate-300"
        >
          {out ? "Stokta yok" : "Sepete Ekle"}
        </button>
      </div>
    </div>
  );
}
